module.exports = __webpack_public_path__ + "media/images/autopilot/setup_step_1_wl-707f6c0a0da79811f329030824338c98.svg";